const utils = require('frontend-controller/lib/utils')

// TODO: move node in super cms via drag and drop uses about 2 seconds?!?

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	config: {
		mode: 'default',
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'routeContentTrees',
				'routeContentTree'
			]
		},
	},

	model: {
		highlightSectionIDs: {},
		highlightRouteComponentIDs: {},
		massInsertSortDelta: 0, // this delta is used to correct the sort index on mass inserts
		chooseComponentUsageScope: '', // which type of components should be allowed to be managed.
	},

	methods: {
		// operations
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, data){
			var self = this;
			var insertWithin = buttonMode === 'within';
			var insertAfter = buttonMode === 'after';
			var insertBefore = buttonMode === 'before';
			var insertRoot = buttonMode === 'root';
			var nodeData = this.getSelectedNodeData();
			var parentComponentNodeData = {}
			if(!insertRoot && nodeData.parentRouteComponentID && nodeData.parentID != nodeData.sectionID){
				var parentNodeIndex;
				if((parentNodeIndex = this.getNodeIndex(nodeData.parentRouteComponentID, 'component'))){
					parentComponentNodeData = this.getNodeData(parentNodeIndex) || {};
				}
			}
			this.deselectActiveNode();
			var actionKey = baseActionKey + '_inEffect';
			var primaryKey;

			this.model.massInsertSortDelta = 0;

			return this.chooseComponent(nodeData, parentComponentNodeData, buttonMode, function(choosenComponentNodeData, wasMassInsert = false){
				var loadModelFieldsPromise;

				// in case of masterComponent usage the model fields has already been loaded
				if(choosenComponentNodeData.routeComponentID){
					loadModelFieldsPromise = utils.promise.resolve(choosenComponentNodeData);
					baseActionKey = 'showDuplicate_routeComponent';
					actionKey = baseActionKey + '_inEffect';
					primaryKey = choosenComponentNodeData.routeComponentID;
				}
				// in case of ordinary components the model fields has to be loaded
				else if(choosenComponentNodeData.componentID){
					loadModelFieldsPromise = self.loadComponentModelFields(choosenComponentNodeData.componentID).then(function(context){ return utils.promise.resolve(((context || {}).action || {}).response); });
				}
				// reject this process otherwise
				else {
					loadModelFieldsPromise = utils.promise.reject();
				}

				return loadModelFieldsPromise.then(function(targetComponent){
					if(self.actions[baseActionKey]){
						var sort,
							sectionID = null,
							parentRouteComponentID;

						if(!insertRoot){
							sort = nodeData.sort;
							if(insertAfter) sort++;
							if(insertAfter || insertBefore) sort += self.model.massInsertSortDelta++
							sectionID = nodeData.sectionID;
							parentRouteComponentID = nodeData.parentRouteComponentID;

							if(insertWithin){
								sort = undefined;
								if(nodeData.type === 'section'){
									if(nodeData.parentType === 'routeComponent'){
										parentRouteComponentID = nodeData.parentID;
									}
									else {
										parentRouteComponentID = undefined;
									}
								}
								else {
									sectionID = null
									parentRouteComponentID = nodeData.routeComponentID;
								}
							}
						}

						return self.performAndStoreAction(
							actionKey,
							self.prepareAction(baseActionKey, primaryKey, {
								nodeData: targetComponent
							}, {
								source: {
									load: {
										componentData: {
											config: {
												preventUserInteraction: wasMassInsert
											},
											actions: {
												loadContent: {
													source: {
														load: {
															componentData: {
																config: {
																	autoSubmitOnAttach: wasMassInsert,
																	onSubmitDoneHandlerOptions: {
																		wasMassInsert
																	}
																},
																model: {
																	dirtyFields: {
																		data: {
																			attributes: {
																				routeID:                self.model.routeID,
																				sectionID:              sectionID,
																				parentRouteComponentID: parentRouteComponentID,
																				sort:                   sort,
																				componentID:            choosenComponentNodeData.componentID
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}),
							true
						);
					}

					return utils.promise.reject();
				});
			});
		},

		/**
		 * instant copy of routeComponent.
		 *
		 * @param baseActionKey
		 * @param buttonContext
		 * @param buttonMode
		 * @param actionBossComponent
		 * @return {*|{resolve}}
		 */
		duplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self        = this;
			var nodeData    = this.getSelectedNodeData();
			var sort        = nodeData.sort + 1;

			if(this.actions[baseActionKey] && nodeData.id){

				return this.performAction(
					this.prepareAction(baseActionKey, nodeData.id, undefined, {
						source: {
							submit: {
								data: {
									data: {
										attributes: {
											sort: sort,
										}
									}
								}
							}
						}
					})
				).then(function(context){
					self.config.readyNodeID = context.response.data.attributes[context.response.data.primaryKey];
					self.config.readyNodeContext = 'component';
					self.refreshTrees();

					return utils.promise.resolve(context);
				});
			}

			return utils.promise.reject();
		},

		/**
		 * show duplicate of routeComponent by user.
		 *
		 * @param baseActionKey
		 * @param buttonContext
		 * @param buttonMode
		 * @param actionBossComponent
		 * @return {*}
		 */
		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self        = this;
			var nodeData    = this.getSelectedNodeData();
			var actionKey 	= baseActionKey + '_inEffect';

			if(this.actions[baseActionKey] && nodeData.id){

				return this.performAndStoreAction(
					actionKey,
					this.prepareAction(baseActionKey, nodeData.id, {
						nodeData
					}, {
						source: {
							load: {
								componentData: {
									actions: {
										loadContent: {
											source: {
												load: {
													componentData: {
														model: {
															dirtyFields: {
																data: {
																	attributes: {
																		routeID:                self.model.routeID,
																		sectionID:              nodeData.sectionID,
																		parentRouteComponentID: nodeData.parentRouteComponentID,
																		sort:                   nodeData.sort + 1,
																		componentID:            nodeData.componentID
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}),
					true
				);
			}

			return utils.promise.reject();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.component.title'),
					message:    storage.__('hint.delete.really.component.message')
				}
			).then(function(context){
				if (context.decision.type === 'yes' && self.actions[baseActionKey]){
					var nodeIndex = self.getSelectedNodeIndex();
					var nodeData = self.getSelectedNodeData();
					self.deselectActiveNode();
					let deleteAction = utils.promise.resolve();

					self.setClosestNodeAsReady(nodeIndex);

					if(buttonContext === 'routeComponent'){
						if(nodeData.routeComponentID != undefined){
							deleteAction = self.performAction(self.prepareAction(baseActionKey, nodeData.routeComponentID))
						}
					}

					deleteAction.then(function(context){
						self.refreshTrees();
						return context;
					})
				}

				return utils.promise.reject();
			});
		},

		showMove: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, data){
			var self = this;
			var nodeData = self.getSelectedNodeData() || {};
			if(buttonMode === 'article'){
				baseActionKey += '_intoProduct'
			}
			var actionKey = baseActionKey + '_inEffect';


			if(buttonContext === 'routeComponent' && self.model.routeID && nodeData.routeComponentID){
				// estimate selected nodes children to prevent errors by selecting move source's child or itself as a target later.
				var c, child;
				var children = self.getNodeChildrenData(self.getSelectedNodeIndex()) || {};
				var invalidMoveTargets = {};
				if(
					nodeData.type &&
					nodeData.primaryKey &&
					nodeData[nodeData.primaryKey]
				){
					invalidMoveTargets[nodeData.type] = {};
					invalidMoveTargets[nodeData.type][nodeData.subType || 'default'] = {};
					invalidMoveTargets[nodeData.type][nodeData.subType || 'default'][nodeData[nodeData.primaryKey]] = {};
				}
				for(c in children){
					child = children[c]
					if(child.type && child.primaryKey && child[child.primaryKey]){
						if(!invalidMoveTargets[child.type]) 							invalidMoveTargets[child.type] = {};
						if(!invalidMoveTargets[child.type][child.subType || 'default']) invalidMoveTargets[child.type][child.subType || 'default'] = {};

						invalidMoveTargets[child.type][child.subType || 'default'][child[child.primaryKey]] = true;
					}
				}

				return self.performAndStoreAction(
					actionKey,
					self.prepareAction(baseActionKey, undefined, {
						moveSource: {
							routeID: 			self.model.routeID,
							routeComponentID: 	nodeData.routeComponentID,
							invalidMoveTargets: invalidMoveTargets
						},
						highlightRouteIDs: 			{[self.model.routeID]: true},
						highlightRouteComponentIDs: {[nodeData.routeComponentID]: true}
					}),
					true
				);
			}

			return utils.promise.reject();
		},

		showImport: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, data){
			var self = this;
			var nodeData = self.getSelectedNodeData() || {};
			if(buttonMode === 'article'){
				baseActionKey += '_fromProduct'
			}
			var actionKey = baseActionKey + '_inEffect';

			this.model.massInsertSortDelta = 0;


			if(self.model.routeID && buttonContext === 'routeComponent'){

				const highlightSectionIDs = {};
				const highlightRouteComponentIDs = {};
				const importTarget = {
					routeID: self.model.routeID,
					sectionID: null
				}

				if(nodeData.sectionID){
					highlightSectionIDs[nodeData.sectionID] = true;
					importTarget.sectionID = nodeData.sectionID;
				}

				if (nodeData.type === 'section' && nodeData.parentType === 'routeComponent'){
					importTarget.parentRouteComponentID = nodeData.parentID
				}
				if (nodeData.parentRouteComponentID){
					importTarget.parentRouteComponentID = nodeData.parentRouteComponentID
				}

				if(nodeData.routeComponentID){
					highlightRouteComponentIDs[nodeData.routeComponentID] = true
					importTarget.routeComponentID 	= nodeData.routeComponentID
					importTarget.sort 				= nodeData.sort
				}

				return self.performAndStoreAction(
					actionKey,
					self.prepareAction(baseActionKey, undefined, {
						importTarget,
						highlightRouteIDs: 			{[importTarget.routeID]: true},
						highlightSectionIDs,
						highlightRouteComponentIDs,
						onRouteContentChosenDecisionOptions: {
							actionKeyInEffect: actionKey
						}
					}, {
					source: {
						load: {
							componentData: {
								config: {
									// prevent useless refreshes during mass inserts
									isRefreshStopper: true
								},
								methods: {
									_modalCallback: function(choosenComponentNodeData, wasMassInsert){

										var primaryKey;
										var loadModelFieldsPromise;

										// in case of masterComponent usage the model fields has already been loaded
										if(choosenComponentNodeData.routeComponentID){
											loadModelFieldsPromise = utils.promise.resolve(choosenComponentNodeData);
											baseActionKey = 'showDuplicate_routeComponent';
											actionKey = baseActionKey + '_inEffect';
											primaryKey = choosenComponentNodeData.routeComponentID;
										}
										// reject this process otherwise
										else {
											loadModelFieldsPromise = utils.promise.reject();
										}

										return loadModelFieldsPromise.then(function(targetComponent){
											if(self.actions[baseActionKey]){
												var sort,
													sectionID = importTarget.sectionID,
													parentRouteComponentID;

												if(importTarget.sort){
													sort = importTarget.sort + 1 + self.model.massInsertSortDelta++;
												}
												parentRouteComponentID = importTarget.parentRouteComponentID;

												return self.performAndStoreAction(
													actionKey,
													self.prepareAction(baseActionKey, primaryKey, {
														nodeData: targetComponent
													}, {
														source: {
															load: {
																componentData: {
																	config: {
																		preventUserInteraction: wasMassInsert
																	},
																	actions: {
																		loadContent: {
																			source: {
																				load: {
																					componentData: {
																						config: {
																							autoSubmitOnAttach: wasMassInsert,
																							onSubmitDoneHandlerOptions: {
																								wasMassInsert
																							}
																						},
																						model: {
																							dirtyFields: {
																								data: {
																									attributes: {
																										routeID:                self.model.routeID,
																										sectionID,
																										parentRouteComponentID,
																										sort,
																										componentID:            choosenComponentNodeData.componentID
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}),
													true
												);
											}

											return utils.promise.reject();
										});
									}
								}
							}
						}
					}

					}),
					true
				);
			}

			return utils.promise.reject();
		},

		showProtocol: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			baseActionKey 		= 'showProtocol'
			const actionKey		= baseActionKey + '_inEffect';
			const nodeData    	= this.getSelectedNodeData();
			const entityID 		= nodeData.id
			const entityType 	= 'routeComponent'

			if(entityID){
				return this.performAndStoreAction(
					actionKey,
					this.prepareAction(baseActionKey, undefined, {
						protocol: {
							entityID,
							entityType
						}
					}),
					true
				);
			}

			return utils.promise.reject();
		},

		loadComponentModelFields: function(componentID){
			return this.performAction(
				this.prepareAction(
					'loadComponentModelFields',
					componentID
				)
			);
		},

		chooseComponent: function(selectedNodeData, parentComponentDataOfSelectedNode, buttonMode, modalCallback){
			var resourceRegister = {};

			if(selectedNodeData.type === 'component'){
				var parentComponentID;
				var freeChildUsageAllowed = false;
				var insertWithin    = buttonMode === 'within';
				var insertRoot      = buttonMode === 'root';

				if(!insertRoot){
					if(insertWithin){
						parentComponentID 		= selectedNodeData.componentID;
						freeChildUsageAllowed 	= selectedNodeData.config && selectedNodeData.config.freeChildUsageAllowed;
					}
					else {
						parentComponentID 		= selectedNodeData.parentComponentID;
						freeChildUsageAllowed 	= parentComponentDataOfSelectedNode && parentComponentDataOfSelectedNode.config && parentComponentDataOfSelectedNode.config.freeChildUsageAllowed;
					}
				}

				resourceRegister.componentTrees = {
					parentComponentID: 		parentComponentID,
					freeChildUsageAllowed: 	freeChildUsageAllowed
				};
			}

			let actionKey = 'chooseComponentModal';
			if(this.model.chooseComponentUsageScope){
				actionKey = `chooseComponentModal_${this.model.chooseComponentUsageScope}`;
			}

			return this.performAndStoreAction(
				'chooseComponentModalInEffect',
				this.prepareAction(
					actionKey,
					undefined,
					resourceRegister,
					{
						source: {
							load: {
								componentData: {
									config: {
										// prevent useless refreshes during mass inserts
										isRefreshStopper: true
									},
									methods: {
										_modalCallback: modalCallback
									}
								}
							}
						}
					}
				),
				true
			);
		},

		sanitizeResourceRegisterContent: function(data, actionSourceName, resourceRegisterContent){
			if(!this.config.limitParentTemplateID && resourceRegisterContent.templateID) this.config.limitParentTemplateID = resourceRegisterContent.templateID;
		},

		sanitizeResources: function(){
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'RouteContents...',
						tree: [],
						nodes: {}
					}
				]
			};

			if(utils.isEmpty(this.resourceData) || this.resourceData.initialized) return;

			// save routeID from routeAttributes if necessary.
			// NOTE: 	this may happen if the routeContentTree has been loaded by path and
			// 			the setRoutePropertiesInComponentTreeRootLeaf hook has been used to prepare
			// 			the additionally loaded route information.
			if((((this.resourceData || [])[0] || {}).routeAttributes || {}).routeID){
				this.model.routeID = this.resourceData[0].routeAttributes.routeID;
				this.config.limitParentTemplateID = this.resourceData[0].routeAttributes.templateID;
			}

			this.config.extendedTreeView = this.hasRoleOption('extendedTreeView');
			this.resetNodeMappings();
			resources.initialized = true;
			var limitParentTemplateID;
			if(this.config.extendRouteContentsByLayouts == undefined) {
				this.config.extendRouteContentsByLayouts = this.hasRoleOption('extendRouteContentsByLayouts');
			}
			if(this.config.extendRouteContentsByShadowComponents == undefined){
				this.config.extendRouteContentsByShadowComponents = this.hasRoleOption('extendRouteContentsByShadowComponents');
			}
			if(this.config.limitParentTemplateID){
				limitParentTemplateID = this.config.limitParentTemplateID;
				if(this.config.extendRouteContentsByLayouts){
					limitParentTemplateID = undefined;
				}
			}
			var treeEntryData = {
				index: 0
			};

			var data = this.getResourceComponentTreeChildren(this.resourceData, limitParentTemplateID, limitParentTemplateID == undefined, undefined, undefined, undefined, treeEntryData);
			resources.trees[0].tree = data.tree;
			resources.trees[0].nodes = data.nodes;

			this.resourceData = resources;
		},

		getResourceComponentTreeChildren: function(resourceComponentTree, limitParentTemplateID, entriesShowable, parentType, parentID, parentIndex, treeEntryData){
			var self = this;
			var baseTree = {
				tree: [],
				nodes: {}
			};

			utils.forEach(Array.isArray(resourceComponentTree) ? resourceComponentTree : [resourceComponentTree], function(element){
				element.primaryKey  = self.getEntriesPrimaryKeyName(element);
				element.id          = element[element.primaryKey];
				element.parentType  = parentType;
				element.parentID    = parentID;

				var treeEntry = self.getResourceTreeEntry(element, entriesShowable, parentType, parentID, parentIndex, treeEntryData);

				if (utils.collectionSize(element.children) > 0) {
					var nextParentType = 'layout';
					if(element.type === 'section' && parentType != undefined)            nextParentType = parentType;
					else if(element.type === 'component' && element.subType != 'layout') nextParentType = 'routeComponent';

					var nextParentID = parentID;
					if(nextParentType === 'routeComponent') nextParentID = element.id;

					var children = self.getResourceComponentTreeChildren(
						element.children,
						limitParentTemplateID,
						(
							(
								entriesShowable
								||
								(element.type === 'component' && element.subType === 'layout' && element.id == limitParentTemplateID)
							)
							&&
							(element.type != 'component' || utils.isEmpty(element.sectionComponentID))
						),
						nextParentType,
						nextParentID,
						treeEntry != undefined ? treeEntry.id : parentIndex,
						treeEntryData
					);
					// if (treeEntry !== undefined)    treeEntry.children = children.tree;
					// else                            baseTree.tree = baseTree.tree.concat(children.tree);
					baseTree.tree = baseTree.tree.concat(children.tree);
					baseTree.nodes = utils.merge(baseTree.nodes, children.nodes);
				}

				if (treeEntry !== undefined) {
					baseTree.tree.push(treeEntry);
					baseTree.nodes[treeEntry.id] = utils.replace(element, {children: undefined});
				}
			});

			return baseTree;
		},

		getResourceTreeEntry: function(treeEntry, entriesShowable, parentType, parentID, parentIndex, treeEntryData){
			var self = this;
			var text, langDependentName;
			const storage = this.getStorage()
			var contextIcon;

			if(!entriesShowable) return;

			var parent = parentIndex != undefined ? parentIndex : '#';
			var additionalClasses = [];

			if(treeEntry.type === 'component' && (self.model.highlightRouteComponentIDs || {})[treeEntry.id]){
				additionalClasses.push('state_highlighted');
			} else if(treeEntry.type === 'section' && (self.model.highlightSectionIDs || {})[treeEntry.id]){
				additionalClasses.push('state_highlighted');
			}
			if(treeEntry.status && treeEntry.status === 'preview'){
				additionalClasses.push('state_preview');
			}
			else if(treeEntry.status && treeEntry.status === 'inactive'){
				additionalClasses.push('state_inactive');
			}

			if(treeEntry.type === 'section'){
				text = treeEntry.code || '';
				if (treeEntry.lang && treeEntry.lang[storage.langCode] && treeEntry.lang[storage.langCode].name) {
					text = treeEntry.lang[storage.langCode].name;
				}
				if(self.config.extendedTreeView) text += ` [#${treeEntry.id} - ${treeEntry.sort || 0}]`;

				// NOTE:    sectionIDs are not unique!
				//          therefor components located within sections of routeComponents has to be positioned
				//          within sections identified by a combined key
				//          which consists of the sectionID and the parentRouteComponentID.
				treeEntryData.index++;
				return {
					id:         self.transformIDToIndex(treeEntry.id + (parentType === 'routeComponent' ? '_' + parentID : ''), 'section', 0, treeEntryData.index - 1),
					parent:     parent,
					text:       text,
					type:       'section',
					state: {
						opened:     true,
						disabled:   false,
						selected:   false
					},
					li_attr:    {},
					a_attr:     {
						class: additionalClasses.join(' ')
					}
				};
			}
			else if(treeEntry.type === 'component') {
				var type;
				var skipEntry = false;

				if (!self.config.extendRouteContentsByShadowComponents && treeEntry.config && treeEntry.config.isShadowComponent){
					skipEntry = true;
				}
				else if(treeEntry.subType === 'default'){
					type = 'component';
					text = treeEntry.component.join('_');
					// skip section components
					skipEntry = treeEntry.routeComponentID == undefined;
				}
				else if(treeEntry.subType === 'layout'){
					type = 'layout';
					text = treeEntry.component.join('_');
				}
				else if(treeEntry.subType === 'form'){
					type = 'component';
					contextIcon = 'fi fi-form';
					text = treeEntry.component.join('_');
					skipEntry = treeEntry.routeComponentID == undefined;
				}

				if(!skipEntry) {
					if(treeEntry.config && treeEntry.config.isShadowComponent){
						contextIcon = 'fi fi-shadowComponent';
						text = treeEntry.config.codeName + ' [' + text + ']';
					}

					if (treeEntry.lang && treeEntry.lang[storage.langCode] && treeEntry.lang[storage.langCode].name) {
						langDependentName = treeEntry.lang[storage.langCode].name;
					}
					if(treeEntry.componentName){
						text = langDependentName + ' (' + treeEntry.componentName + ')';
					}
					else {
						text = langDependentName;
					}

					if(self.config.extendedTreeView) text += ` [#${treeEntry.id} - ${treeEntry.sort || 0}]`;

					// the config of a component can force an special icon for a component by setting "forceContextIcon" with value of fi-icon (e.g. "fi fi-cubes")
					if((treeEntry.config || {}).forceContextIcon || false){
						contextIcon = treeEntry.config.forceContextIcon;
					}

					treeEntryData.index++;
					return {
						id: self.transformIDToIndex(treeEntry.id, type, 0, treeEntryData.index - 1),
						parent: parent,
						text: text || '',
						type: type,
						icon: contextIcon,
						state: {
							opened: true,
							disabled: false,
							selected: false
						},
						li_attr: {},
						a_attr: {
							class: additionalClasses.join(' ')
						}
					};
				}
			}
		},

		/**
		 * this function is used to return the primary key of the given entry
		 *
		 * @param   entry       {} - tree entry
		 * @returns string      primary key name
		 */
		getEntriesPrimaryKeyName: function(entry){
			if(entry.type === 'section'){
				return 'sectionID';
			}
			else if(entry.type === 'component'){
				if(entry.subType === 'layout'){
					return 'templateID';
				}
				else {
					return 'routeComponentID';
				}
			}

			return 'UNKNOWN_PK';
		},

		handleError: function(context){
			const baseError = utils.extractBaseError(context.error);

			if(baseError.statusCode == 404 && baseError.errorCode === 'COMPONENT_TREE_BUILDER_ERROR_7'){
				// TODO: maybe tell routeTree to reload?
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:routeContentTree.loadMissingRoute'
						}
					}, {
						rollbackContext: context,
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				);
			}

			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		},

		// TODO: DOC
		onTreeAction: function (data) {
			var self = this;
			// TODO: CLEANUP
			// console.log('ROUTE CONTENT TREES - onTreeAction', data, this.model.states);
			var actionFormsSelector = '.base_treesManagement_actionsForm';

			switch (data.onTreeActionOptions.eventType) {
				case 'move_node.jstree':
					var moveEntry = data.onTreeActionOptions.eventData.node;
					var moveEntryContext = this.getNodeContext(moveEntry.id);
					var actionKey = data.onTreeActionOptions.operation  + '_' + moveEntryContext;
					if(this.actions[actionKey]){
						var moveNode = this.getNodeData(moveEntry.id);
						var newInParentPosition = data.onTreeActionOptions.eventData.position;
						var newParentEntry, newParentNode;
						var movementAttributes;
						if(moveEntry.parent && moveEntry.parent != '#'){
							newParentEntry = this.getNode(moveEntry.parent);
							newParentNode = this.getNodeData(moveEntry.parent);
						}

						if(moveEntryContext === 'component'){
							movementAttributes = {
								routeID:                this.model.routeID,
								parentRouteComponentID: 0,
								sectionID:              null,
								sort:                   this.getNewSortFieldValue(
									moveEntryContext,
									moveEntry.parent,
									newInParentPosition,
									(newParentNode ? newParentNode.sort : undefined),
									function(nodeEntry, nodeData){
										// is this a component entry?
										return nodeEntry.id != moveEntry.id && nodeData.routeComponentID != undefined;
									},
									data.onTreeActionOptions.treeComponentIndex
								)
							};

							// estimate right parent parentCategoryID
							if(newParentNode){
								if(newParentNode.type === 'section'){
									movementAttributes.sectionID = newParentNode.id;

									if(newParentNode.parentType === 'routeComponent'){
										movementAttributes.parentRouteComponentID = newParentNode.parentID;
									}
								}
								else if(newParentNode.type === 'component'){
									movementAttributes.parentRouteComponentID = newParentNode.routeComponentID;
								}

							}
						}

						if(movementAttributes){
							this.performAction(
								this.prepareAction(actionKey, moveNode.id, undefined, {
									source: {
										submit: {
											data: {
												data: {
													attributes: movementAttributes
												}
											}
										}
									}
								})
							).then(function(){
								// refresh to get the lists up to date after movement
								self.refreshTrees();
							}).fail(function(error){
								// prevent wrong gui state from being displayed
								self.refreshTrees();
							});
						}
						else {
							self.refreshTrees();
							throw new Error('NO MOVEMENT ATTRIBUTES FOUND: ' + actionKey + ', ' + moveEntryContext);
						}
					}
					else {
						self.refreshTrees();
						throw new Error('ACTION NOT FOUND: ' + actionKey);
					}

					break;

				case 'select_node.jstree':
					// hide all action forms
					this.$.find(actionFormsSelector).hide();

					if(this.config.mode !== 'chooser'){
						// layout found?
						if(data.onTreeActionOptions.eventData.node.type === 'layout'){
							var nextSectionNodeIndex = this.getNodeIndexAfter(undefined, 'section');
							if(nextSectionNodeIndex != undefined){
								this.deselectActiveNode();
								this.selectNodeByIndex(nextSectionNodeIndex)
							}
						}
						else {
							this.$.find(actionFormsSelector).hide();
							var selector = '.routeContentTreeActions';
							if (data.onTreeActionOptions.eventData.node.type === 'section'){
								selector = '.routeContentTreeSectionActions';
								this.$.find('.base_treesManagement_propertiesForm').hide();
							}
							this.$.find(selector).show();
						}
					}

					// TODO: impl. animation and animation-delay
					break;

				case 'deselect_node.jstree':
					// hide page actions if necessary
					this.$.find(actionFormsSelector).hide();
					break;
			}
		},

		// prepare routeID for later usage
		onAttachDone: function(){
			var routeResourceRegister = this.getResourceRegisterContent('routeTreeParent');
			if(!this.model.routeID && routeResourceRegister && routeResourceRegister.resourceID){
				this.model.routeID = routeResourceRegister.resourceID;
				if(routeResourceRegister.type === 'newsletter' || routeResourceRegister.type === 'mail'){
					this.model.chooseComponentUsageScope = 'newsletter'
				}
			}

			if(this.config.extendRouteContentsByLayouts && this.config.mode !== 'chooser'){
				var subActionsHtml;
				// NOTE:    trees does not contain subActions necessarily.
				//          therefor the potential error (subActions not found) will be ignored.
				try {
					subActionsHtml = this.include('subActions');
					var $parent = this.$.find('section.actions');
					if($parent.length <= 0) $parent = this.$;
					$parent.append(subActionsHtml);
				} catch(error){}
			}
		}
	},

	hooks: {
		async onDecision($element, options){
			const decisionOptions = options.decisionOptions || {};
			const actionKeyInEffect = decisionOptions.actionKeyInEffect || 'chooseComponentModalInEffect';

			switch(options.decisionType){
				case 'submit':
					if(
						options.decisionComponent.hasClass('templates_componentTrees_selectComponentTrees')
						||
						options.decisionComponent.hasClass('templates_routeContentTrees_duplicateMasterComponentSelectRouteContentTrees')
						||
						options.decisionComponent.hasClass('templates_routeContentTrees_chooseRouteContentTrees')
					){
						if(utils.isFunction(this.actions[actionKeyInEffect].source.load.component._modalCallback)){
							this.actions[actionKeyInEffect].source.load.component._modalCallback(options.data, decisionOptions.wasMassInsert);
						}
					} else if(options.decisionComponent.hasClass('base_modal_modal')){
						const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
						if(modalContentComponent && modalContentComponent.hasClass('templates_propertiesForms_componentContentForm')){
							await modalContentComponent.submit()
						}
					}
					break

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide()
							break;
					}
					break

				default:
					// TODO: ERROR;
					break
			}

			if(this.actions[actionKeyInEffect] && !decisionOptions.wasMassInsert){
				await this.actions[actionKeyInEffect].source.load.component.hide()
			}
		},

		async onRouteComponentMovedToAnotherRoute($element, options){
			// hide modal
			let modal
			options.component.closest('base_modal_modal', c => modal = c)
			if(modal){
				await modal.hide()
			}

			// refresh data
			this.refreshTrees()

			// show success message
			let statusController
			if((statusController = getComponent('statusController'))){
				if(options.success){
					statusController.addPanel('status.done.move')
				} else {
					statusController.addPanel('status.done.move')
				}
			}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_componentContentForm',
			handle: function(callerComponent){
				// CHECK IF THE CALLER IS A CHILD OF THIS ROUTE CONTENT TREE
				var self = this;
				callerComponent.closest('templates_routeContentTrees_routeContentTrees', function(routeContentTrees){
					if(routeContentTrees.componentIndex === self.componentIndex){
						self.deselectActiveNode();
					}
				});
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_componentContentForm',
			handle: function(callerComponent, nodeData, insertPerformed, options){
				// CHECK IF THE CALLER IS A CHILD OF THIS ROUTE CONTENT TREE
				var self = this;
				options = options || {};

				callerComponent.closest('templates_routeContentTrees_routeContentTrees', function(routeContentTrees){
					if(routeContentTrees.componentIndex === self.componentIndex){
						// hide parentModal if necessary
						callerComponent.parent(async potentialModal => {
							if(potentialModal.hasClass('base_modal_modal')){
								await potentialModal.hide()
							}
						})

						if(insertPerformed && !options.wasMassInsert){
							self.config.readyNodeID = nodeData.data.attributes[nodeData.data.primaryKey];
							self.config.readyNodeContext = 'component';
						}
						self.refreshTrees();
					}
				}, true)

				// TODO: this special case interferes with the gui handling of a user since the user's ctrl-clicks lead to treeRefreshes.
				// if(options.wasMassInsert && self.hasClass('templates_routeContentTrees_chooseRouteContentTrees')){
				// 	// in special cases it may be necessary to refresh the actual tree (e.g., importRouteComponent from the very same route)
				// 	self.refreshTrees();
				// }
			}
		}
	]
};
